import React from 'react';
import PropTypes from 'prop-types';
import styles from './GiftToggle.module.css';

const giftIcon = require('./gift.svg');

const GiftToggle = ({ isGift, onChange, label, disabled, isBrandRefresh }) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!isGift);
    }
  };

  const containerClass = isBrandRefresh
    ? `${styles.giftToggleContainer} ${styles.brandRefresh}`
    : styles.giftToggleContainer;

  return (
    <div className={containerClass} data-part={isBrandRefresh ? 'gift-toggle' : undefined}>
      <div className={styles.giftToggleContent}>
        <div className={styles.giftToggleIcon}>
          <img 
            src={giftIcon} 
            alt="Gift" 
            className={styles.giftIconImage}
          />
        </div>
        <div className={styles.giftToggleText}>
          <span className={styles.giftToggleLabel}>
            {label}
          </span>
          <span className={styles.giftToggleSubtext}>
            Gift box sleeves available
          </span>
        </div>
      </div>
      <label className={styles.toggleSwitch} htmlFor="gift-toggle">
        <input
          id="gift-toggle"
          type="checkbox"
          checked={isGift}
          onChange={handleToggle}
          disabled={disabled}
          className={styles.toggleInput}
        />
        <span className={styles.toggleSlider}>
          <span className={styles.toggleDot} />
        </span>
      </label>
    </div>
  );
};

GiftToggle.propTypes = {
  isGift: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isBrandRefresh: PropTypes.bool,
};

GiftToggle.defaultProps = {
  label: 'This is a gift',
  disabled: false,
  isBrandRefresh: false,
};

export default GiftToggle;